import { index as getList } from "~/api/siteQuickMode";
import * as types from "../mutation-types";
import store from "../../store";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";
import { clearableStore } from '~/mixins/clearableStore';

export const state = {
    list: null,
    isLoading: false,
    isInitialLoadPending: true,
};

export const mutations = {
    ...clearableStore.mutations,
    [types.SET_IS_LOADING_SITE_QUICK_MODE](state, status) {
        state.isLoading = status;
    },
    [types.SET_SITE_QUICK_MODE](state, siteQuickMode) {
        state.list = siteQuickMode.data;
        state.isInitialLoadPending = false;
    }
};

export const actions = {
    fetchSiteQuickModes({ commit }, contractId = null) {
        commit(types.SET_IS_LOADING_SITE_QUICK_MODE, true);

        let activeContractId =
            contractId || store.getters["contract/activeContract"]?.id;

        if (activeContractId) {
            getList(activeContractId).then((response) => {
                let { data } = response;
                commit(types.SET_SITE_QUICK_MODE, data);
                commit(types.SET_IS_LOADING_SITE_QUICK_MODE, false);
            }).catch(() => {
                commit(types.SET_IS_LOADING_SITE_QUICK_MODE, false);
            });
        }
    }
};

export const getters = {
    list: (state) => state.list,
    isLoading: (state) => state.isLoading,
    isInitialLoadPending: (state) => state.isInitialLoadPending,
    hasActiveProcesses: (state) => {
        return state.list && Array.isArray(state.list) && state.list.length > 0;
    },
    ...entityStoreStatus.getters
};






